import React, { useState, useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Typography } from '@mui/material'
import { Dropdown, DropdownButton } from 'react-bootstrap'

import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import PopupModal from 'Shared/Components/PopupModal'
import TypeForm from './Forms/TypeForm'
import BackLinkButton from 'Shared/Components/BackLinkButton'

const AssetTypesDetail = () => {
  const { role, projectInfo, setPageLoading } = useOutletContext()
  
  const { t } = useTranslation()
  const { type_id } = useParams()
  const { send } = useFetchData()

  const [data, setData] = useState()
  const [isformOpen, setFormOpen] = useState(false)

  const getEquipments = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/assets_tracking/types/detail`,
      params: {
        "type_id": type_id
      },
      returnType: "json"
    })

    body && setData(body)
  }

  const loadData = async () => {
    await Promise.all([
      getEquipments()
    ])
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await loadData()

      setPageLoading(false)
    }

    init()
  }, [])

  const reload = async () => {
    await loadData()
  }

  return (<>
    <div className="mainContainer scrollbar" style={{ borderRadius: "15px", backgroundColor: "white", overflow: "auto" }}>
      {data && <>
        <div style={{ display: "flex", justifyContent: "space-between", marginRight: "15px" }}>
          <BackLinkButton />

          <DropdownButton title={t("general_action")}>
            <Dropdown.Item onClick={() => setFormOpen(true)}>{t("general_edit")}</Dropdown.Item>
          </DropdownButton>
        </div>
        
        <div style={{ margin: "20px 15px 20px 15px" }}>
          <div>
            <Typography variant="h6"><b>{t("assetsTracking_typeDetail")}</b></Typography>

            <div>
              <div>{t("assetsTracking_equipmentType")}: {data["detail"]["type_name"] ?? "-"}</div>
              <div>{t("assetsTracking_equipmentDescription")}: {data["detail"]["description"] ?? "-"}</div>
            </div>
          </div>
        </div>

        <PopupModal isOpen={isformOpen} close toggle={() => setFormOpen(false)} width="80%" height="80%">
          <TypeForm
            mode="edit" type_id={type_id} reload={reload}
            initialState={{
              "type_name": data["detail"]["type_name"],
              "description": data["detail"]["description"]
            }}
          />
        </PopupModal>
      </>}
    </div>
  </>)
}

export default AssetTypesDetail
